<ncp-table #socialHistory [(options)]="options"></ncp-table>
